module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6b8630fa9df06dd65ac79d74298bc03.png";